import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/site";

export default function FaqPreview() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const list = faqs.slice(0, 4);

  return (
    <section className="bg-background-100 border-b border-background-200">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <p className="text-xs tracking-[0.18em] text-primary-600 mb-2.5">常见问题</p>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">关于看点，你可能想问</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              更新节奏、筛选标准、订阅方式，这里集中回答几个被问得最多的问题。
            </p>
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-1.5 text-sm text-foreground-700 hover:text-primary-700 transition-colors"
            >
              查看全部问题 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:col-span-8">
            <div className="rounded-lg bg-background-50 border border-background-200 divide-y divide-background-200">
              {list.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={item.q}>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="w-full flex items-start justify-between gap-4 text-left px-5 md:px-6 py-5 cursor-pointer"
                    >
                      <span className="text-sm md:text-base font-medium text-foreground-950">{item.q}</span>
                      <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-lg text-primary-600 shrink-0 mt-0.5`}></i>
                    </button>
                    {isOpen && (
                      <div className="px-5 md:px-6 pb-5 -mt-1">
                        <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}